<template>
    <div class="dingdan">
        <breadcrumb :routerList="[{to:'/dingd/material/inland',title:'订单管理'}]"/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                    <el-form-item label="客户名称">
                        <el-input v-model="formInline.cunameLike" placeholder="请输入"></el-input>
                        <!--                        <el-select v-model="formInline.cucode"-->
                        <!--                                   placeholder="请选择" clearable>-->
                        <!--                            <el-option v-for="item in tableData"-->
                        <!--                                       :label="item.cuname"-->
                        <!--                                       :value="item.cucode">-->
                        <!--                                {{ item.cuname }}-->
                        <!--                            </el-option>-->
                        <!--                        </el-select>-->
                    </el-form-item>

                    <el-form-item label="销售组织">
                        <brselect category="xiaoshou_zuzhi" :v="formInline.spare8"
                                  v-model="formInline.spare8" style="width:3rem" clearable></brselect>
                        <!--                        <el-select v-model="formInline.spare8" style="width:2rem" clearable>-->
                        <!--                            <el-option label="类别一" value="1"></el-option>-->
                        <!--                            <el-option label="类别二" value="2"></el-option>-->
                        <!--                        </el-select>-->
                    </el-form-item>
                    <el-form-item label="订单类型">
                        <el-select v-model="formInline.orderCategory" style="width:1.5rem" clearable>
                            <el-option label="内销订单" value="1"></el-option>
                            <el-option label="外销订单" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item class="h-formBtnOut">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn" @click="resetData" style="background-color:white;color:black;border:1px solid #d1d1d1">重置</el-button>
                        <router-link to='/dingd/material/neixiao'>
                            <el-button class="h-btn h-formBtn h-bggreen h-mr20" icon="el-icon-plus" style="width:2rem;">
                                新建订单
                            </el-button>
                        </router-link>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30" v-if="clickActive==1">
            <el-table
                    @selection-change="handleSelectionChange"
                    :data="tableData"
					border
                    style="width: 100%"
            >
                <el-table-column
                        type="selection"
                        width="70"
                        :label="all"
                >
                </el-table-column>
                <el-table-column
                        
                        type="index"
                        label="序号"
                        width="65">
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        label="客户名称"
                        min-width="150"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="spare8"
                        label="销售组织"
						:show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <dictname category="xiaoshou_zuzhi" :v="scope.row.spare8"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="toAddress"
                        label="收货单位名称"
						:show-overflow-tooltip="true"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="contactName"
						:show-overflow-tooltip="true"
                        label="联系人"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="orderCategory"
						:show-overflow-tooltip="true"
                        label="订单类型"
                        width="100"
                >
                    <template slot-scope="scope">
                        <dictname category="xiaoshou_quyu"  :v="scope.row.orderCategory"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="proModelCode"
                        label="产品型号"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="receivedTime"
                        label="预计收货日期"
						:show-overflow-tooltip="true"
                        width="130">
                </el-table-column>
                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        width="100">
                    <template slot-scope="scope">
                        <dictname category="shifou_keyong"  :v="scope.row.isStockUp"/>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="120"
                >
                    <template slot-scope="scope">
                       <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="goDetails(scope.row.orderId)">
                            查看
                        </el-button>
                        <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                v-model="scope.row.id"
                                @click="deleteByIdLogi(scope.row.id)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox" style="justify-content: initial;">
							<span class="l-operationlist br-operation-look" title="查看" @click="goDetails(scope.row.orderId)"></span>
							<span class="l-operationlist br-operation-delete" title="删除" @click="deleteByIdLogi(scope.row.id)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="h-tableB h-mrt30">
            <div class="h-tableBL">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="downloadExcel">
                    批量导出
                </el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="daoru">批量导入</el-button>
            </div>
            <div class="h-pagination2">
                <pagination :page="q" @query="query"/>
            </div>
        </div>

        <!--        <div class="h-tableBL">-->
        <!--            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>-->
        <!--            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export">批量导入</el-button>-->
        <!--        </div>-->
        <!--        -->
        <!--        <div class="h-pagination2 h-pageCenter">-->
        <!--            <pagination :page="q" @query="query"/>-->
        <!--        </div>-->
        <el-dialog :visible.sync="dialogFormVisible2" width="53%" class="h-dialog3 dialogFormVisible3">
                <div class="h-dialogImg">
                    <div style="display:flex;align-items:center;">
                        <img src="../../../assets/images/daoru-j.png" alt="" style="width: 86px;height: 86px;">
                        <div>
                            <p class="piliang1">批量导入</p>
                            <p class="piliang2">导入文件请先下载模版并按照模版填写完成后，点击上传文件，上传文件不大于200M</p>
                        </div>
                    </div>
                    
                    <div class="piliangBox">
                        <div class="imgs"><img src="../../../assets/images/daoru-exls.png" alt=""
                                               style="width: 40px;height: 39px;"></div>
                        <div class="imgs">批量导入模版文件.xlsx</div>
                        <div class="imgs" style="color: #0865c4;cursor:pointer;">下载</div>
                    </div>
                    <div style="width:100%;">
                        <el-upload
                                action="https://jsonplaceholder.typicode.com/posts/"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove"
                                style="width:100%;">
                            <div style="width:100%;">+ 上传文件</div>
                        </el-upload>
                    </div>
                    <div style="display:flex;justify-content:center;margin-top:30px;">
                        <el-button class="h-btn h-formBtn h-bgwhite" type="primary" @click="dialogFormVisible2 = false">
                            取消
                        </el-button>
                        <el-button class="h-btn h-formBtn" type="primary" style="margin-left:40px;"
                                   @click="dialogFormVisible2 = false">提交
                        </el-button>
                    </div>
                </div>
            </el-dialog>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile';

    export default {
        data() {
            return {
                dialogFormVisible2:false,
                //表单
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    cucode: '',
                    spare8: '',
                    orderCategory: '',
                    ids: [],
                },
                all: '全部',
                formInline: {},
                //表格
                multipleSelection: [],
                tableData: [],

                clickActive: 1,

                handleSizeChange: '',
                handleCurrentChange: '',
            }
        },
        methods: {
            daoru() {
                this.dialogFormVisible2 = true;
            },
            //查看详情跳转
            goDetails(x){
                console.log(x)
                this.$router.push({path:"/dingd/material/ownDetails", query:{orderId: x}})
            },
            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                this.q.orderCategory = this.formInline.orderCategory;
                this.q.spare8 = this.formInline.spare8;
                this.q.cucode = this.formInline.cucode;
                this.q.cunameLike = this.formInline.cunameLike;

                ss.OrderService.getAllOrderProByUserIdPage(this.q).then(rd => {
                    this.tableData = rd.records;
                    this.q.total = rd.total;
                });
            },

            //查询该用户所有订单详情
            querySingle() {
                ss.OrderService.getOrderProByUserIdPage(this.q).then(rd => {
                    this.tableData = rd.records;
                    this.q.total = rd.total;
                });
            },
            //检索
            handleFilter() {
                this.query();
            },
            //逻辑删除某条产品
            deleteByIdLogi(x) {
                this.$msg.confirm("确认删除?", () => {
                    ss.OrderService.deleteByIdLogi(x).then(rd => {
                        console.log('删除结果:' + rd)
                        this.query();
                    });
                })

            },
            // 重置按钮
            resetData() {
                this.formInline.cucode = ""
                this.formInline.cunameLike = ""
                this.formInline.spare8 = ""
                this.formInline.orderCategory = ""
                this.q.pageSize = 10;
                this.query();
            },
            //导出Excel
            downloadExcel() {

                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });

                this.q.ids = idlist;
                this.q.orderCategory = this.formInline.orderCategory;
                this.q.spare8 = this.formInline.spare8;
                this.q.cucode = this.formInline.cucode;
                this.q.cunameLike = this.formInline.cunameLike;

                updownfile.down("/api/swyl/v1/bsc/order/getOrderExcel?ids=" + this.q.ids, this.q.ids, "get", "data");

            }
        },

        mounted() {
        },

        created() {
            this.query();
        }
    }
</script>
<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

</style>
<style>
   .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }
    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;
        
        margin-bottom: 20px;
    }
    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 10px;
        
    }
</style>


